import { BC_NAME_SYNC } from '@mobile-mapping/providers';
import { PaneViewer, StationLoadProvider } from '@mobile-mapping/ui';
import { ViewMode } from '@mobile-mapping/web3d';
import { PaneLayouts } from '@trimble/pane-layout';
import { createBCSyncer } from '@trimble/utilities';
import { createMemo, createSignal, JSX } from 'solid-js';
import { createStore } from 'solid-js/store';
import { useUrlSync } from '../hooks/useUrlSync';

const PopupPage = (): JSX.Element => {
  const [pointCloudContents, setPointCloudContents] = createSignal([]);
  const [alignmentContents, setAlignmentContents] = createSignal([]);
  const [panoramaContents, setPanoramaContents] = createSignal([]);
  const [planarContents, setPlanarContents] = createSignal([]);
  const [map2DPaneContents, setMap2DPaneContents] = createSignal([]);
  const contents = createMemo(() => ({
    pointCloudContents: pointCloudContents,
    alignmentContents: alignmentContents,
    panoramaContents: panoramaContents,
    planarContents: planarContents,
    map2DPaneContents: map2DPaneContents,
  }));

  createBCSyncer(
    BC_NAME_SYNC.PointsCloudContents,
    false,
    setPointCloudContents
  );
  createBCSyncer(BC_NAME_SYNC.AlignmentContents, false, setAlignmentContents);
  createBCSyncer(BC_NAME_SYNC.PanoramaContents, false, setPanoramaContents);
  createBCSyncer(BC_NAME_SYNC.PlanarContents, false, setPlanarContents);
  createBCSyncer(BC_NAME_SYNC.Map2DPaneContent, false, setMap2DPaneContents);

  useUrlSync();

  const initValues: PaneLayouts<ViewMode> = {
    version: '3',
    activeLayoutLabel: '1',
    layouts: [
      {
        label: '1',
        paneRows: [
          {
            config: {
              size: 1,
              minSize: 0.2,
            },
            cells: [
              {
                contentConfig: { type: '3D' },
                size: 1,
                minSize: 0.2,
              },
            ],
          },
        ],
      },
    ],
  };

  const [layouts, setLayouts] = createStore<PaneLayouts<ViewMode>>(initValues);

  return (
    <div class="h-screen">
      <StationLoadProvider planarContents={planarContents}>
        <PaneViewer
          data={contents()}
          web3DPath={import.meta.env.VITE_WEB3D_PATH}
          allowPopup={false}
          layoutConfig={{
            rowIdx: 0,
            cellIdx: 0,
            layouts,
            setLayouts,
          }}
        />
      </StationLoadProvider>
    </div>
  );
};

export default PopupPage;
